import { setupWorker } from "msw";
import { createHandler } from "./handlers.js";
import { getIsActive } from "../services/service.js";
const initMockServiceWorker = (groupMockDebugs) => {
  if (getIsActive()) {
    setupWorker(...createHandler(groupMockDebugs)).start({
      onUnhandledRequest: "bypass"
    });
  }
};
export {
  initMockServiceWorker
};
//# sourceMappingURL=browser.js.map
